import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/candy_404.webp'


const _withScopeId = n => (_pushScopeId("data-v-18dd3b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "candy-notfound" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Oooopsss, parece que aqui no hay dulces!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "candy-notfound__content__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "404 candy logo"
  })
], -1))

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const goHome = () => {
  router.replace("/");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "candy-notfound__content" }, [
      _createElementVNode("div", { class: "candy-notfound__title" }, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "btn-candy",
          onClick: goHome
        }, "Volver a los dulces")
      ]),
      _hoisted_3
    ])
  ]))
}
}

})